import { ItemList } from "../../orm";

class AdminUsersList extends ItemList {

  getEntityKey() {
    return "admin/user";
  }

}

class AdminResetUserPasswordList extends ItemList {
  getEntityKey() {
    return "admin/user/reset_user_password";
  }
}

export const adminUsersList = new AdminUsersList("admin_users__default");
export const adminResetUserPasswordList = new AdminResetUserPasswordList("admin_reset_user_password__default");
